(function () {
	function openModalVariant(selector) {
		const modal = document.querySelector(selector);
		if (!modal) return;
		modal.classList.add("active");
		const input = modal.querySelector(".search__input");
		if (input) {
			input.focus();
		} else {
			const trigger = document.querySelector(".search-modal-trigger");
			if (trigger) trigger.focus();
		}
	}

	function closeModalVariant(selector) {
		const modal = document.querySelector(selector);
		if (!modal) return;
		modal.classList.remove("active");
		const input = modal.querySelector(".search__input");
		if (input) {
			input.focus();
		} else {
			const trigger = document.querySelector(".search-modal-trigger");
			if (trigger) trigger.focus();
		}
	}

	function searchOpen() {
		openModalVariant("#search-modal");
		openModalVariant("#search-modal-mobile");

		const overlay = document.querySelector(".search-modal__overlay");
		const overlayHidden = overlay ? overlay.classList.contains("hide-overlay") : false;

		if (overlayHidden) {
			document.body.classList.remove("overflow-hidden");
		} else {
			document.body.classList.add("overflow-hidden");
		}

		const header = document.querySelector(".shopify-section-header");
		if (header && header.classList.contains("header-overlay") && !overlayHidden) {
			header.classList.remove("color-inverse");
		}
	}

	function searchClose() {
		closeModalVariant("#search-modal");
		closeModalVariant("#search-modal-mobile");

		const formMain = document.querySelector(".search-modal__form-main");
		if (formMain && formMain.hasAttribute("open")) {
			formMain.removeAttribute("open");
		}

		document.body.classList.remove("overflow-hidden");

		const header = document.querySelector(".shopify-section-header");
		if (header && header.classList.contains("header-overlay") && !header.classList.contains("shopify-section-header-sticky")) {
			header.classList.add("color-inverse");
		}
	}

	const searchModal = () => {
		document.querySelectorAll(".search__form-inner,.search-mobile-trigger").forEach(function (el) {
			el.addEventListener("click", function (e) {
				e.preventDefault();
				searchOpen();
			});
		});
		document.querySelectorAll(".search-modal__overlay,.search__close,.search-mobile-close").forEach(function (el) {
			el.addEventListener("click", function (e) {
				e.preventDefault();
				searchClose();
			});
		});
	};

	document.addEventListener("keyup", function (e) {
		const modal = document.querySelector(".search-modal");
		if (modal && modal.classList.contains("active") && e.key == "Escape") {
			searchClose();
		}
	});

	document.addEventListener("shopify:section:load", searchModal);
	searchModal();
})();
